// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/AreaType.yaml
// Generated: 2026-10-20T12:35:06.500Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateAreaType, UpdateAreaType, AreaType } from '@/types/core/AreaType';

/**
 * AreaType Service
 * CRUD operations for AreaType via the ABP API.
 */
export const areaTypeService = new EntityService<AreaType, CreateAreaType, UpdateAreaType>(
  '/api/core/areatype',
  'AreaType',
);
